export default "__VITE_ASSET__uLSThP1g__"